import { TNullable } from '@/types';

/**
 * Combines first and last names into a single string, trimming extra spaces.
 * @param firstName - The user's first name, nullable or undefined.
 * @param lastName - The user's last name, nullable or undefined.
 * @returns Formatted full name as a string.
 */
export const nameFormat = (
  firstName: TNullable<string | undefined>,
  lastName: TNullable<string | undefined>,
) => {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim();
};

/**
 * Generates the initials of a user from first and last names.
 * @param firstName - The user's first name, nullable or undefined.
 * @param lastName - The user's last name, nullable or undefined.
 * @returns Uppercase initials string.
 */
export const getUserInitials = (
  firstName: TNullable<string | undefined>,
  lastName: TNullable<string | undefined>,
): string => {
  return `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase();
};

/**
 * Formats a session ID by prefixing it with `#`.
 * @param sessionId - The session ID string.
 * @returns Formatted session ID string.
 */
export const sessionIdFormat = (sessionId: string) => `#${sessionId}`;
